/* eslint-disable no-console */


if (process.env.NODE_ENV === 'production') {
  //
}
